import { createSelector } from '@ngrx/store';
import { AppState } from '../app.state';
import { ValueState } from '../states/value.state';

export const selectValueFeature = (state: AppState) => state.value;

export const setValues = createSelector(
    selectValueFeature,
    (state: ValueState) => state.values
  );

export const setSelectedValue = createSelector(
    selectValueFeature,
    (state: ValueState) => state.selectedValue
  );

export const setListStatus = createSelector(
    selectValueFeature,
    (state: ValueState) => state.listStatus
);

export const setGetStatus = createSelector(
  selectValueFeature,
  (state: ValueState) => state.getStatus
);
